import "./App.css"
import React, { useEffect, useState, useCallback } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Hjem from "./Pages/Hjem"
import Informasjon from "./Pages/Informasjon"
import Huskeliste from "./Pages/Huskeliste"
import Anbefalinger from "./anbefalinger/Anbefalinger"
import PraktiskInfo from "./Pages/PraktiskInfo"
import Layout from "./Pages/Layout"
import { Auth } from "@supabase/auth-ui-react"
import { ThemeSupa } from "@supabase/auth-ui-shared"
import supabase from "./supabaseconfig"
import { User } from "./types/supabase"
import { useBrukerContext } from "./BrukerContext"

export function Innhold() {
    const [session, setSession] = useState(null)
    const [laster, setLaster] = useState(true)
    const [harTilgang, setHarTilgang] = useState(false)
    const { oppdaterBruker } = useBrukerContext()

    useEffect(() => {
        supabase()
            .auth.getSession()
            .then(({ data: { session } }) => {
                setSession(session)
                if (!session) setLaster(false)
            })

        const {
            data: { subscription },
        } = supabase().auth.onAuthStateChange((_event, session) => {
            setSession(session)
        })

        return () => subscription.unsubscribe()
    }, [])

    const getUserRole = useCallback(async (): Promise<void> => {
        const { data: { user } } = await supabase().auth.getUser()
        if (!user) { setLaster(false); return }

        const { data, error } = await supabase()
            .from("users")
            .select("*")
            .eq("id", user.id)
            .eq("role", "tilgang")
            .returns<User[]>()

        if (error) {
            console.error("Feil ved henting av brukerrolle:", error)
            setLaster(false)
            return
        }

        if (data && data.length > 0) {
            setHarTilgang(true)
            oppdaterBruker(data[0].name)
        }
        setLaster(false)
    }, [oppdaterBruker])

    useEffect(() => {
        if (session) {
            getUserRole()
        }
    }, [session, getUserRole])

    if (laster) {
        return null
    }

    if (!session) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    minHeight: "100vh",
                }}
            >
                <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <h1 style={{ fontFamily: "var(--serif)", fontSize: "2.5rem", fontWeight: 700, letterSpacing: "-0.03em", marginBottom: "0.25rem" }}>Residencen</h1>
                    <p style={{ fontFamily: "var(--sans)", fontSize: "0.9rem", color: "var(--muted)", marginBottom: "3rem", marginTop: 0 }}>Praktisk informasjon for brukere av Residencen</p>
                    <Auth
                        supabaseClient={supabase()}
                        appearance={{ theme: ThemeSupa }}
                        providers={["google"]}
                        onlyThirdPartyProviders
                    />
                </div>
                <footer className="sideFooter">
                    <a href="/personvern.html">Personvern</a>
                    <a href="/vilkar.html">Vilkår</a>
                </footer>
            </div>
        )
    } else if (!harTilgang) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                }}
            >
                <h1>Du har ikke tilgang til denne siden</h1>
                <p>Gi beskjed til Emilie så legger hun deg til</p>
            </div>
        )
    } else {
        return (
            <BrowserRouter
                future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true,
                }}
            >
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Hjem />} />
                        <Route path="leie" element={<Informasjon />} />
                        <Route path="anbefalinger" element={<Anbefalinger />} />
                        <Route path="huskeliste" element={<Huskeliste />} />
                        <Route path="praktisk-info" element={<PraktiskInfo />} />
                        <Route path="*" element={<Hjem />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        )
    }
}
